import { AlertNotification } from 'common/types/alertNotification';

import { createCtx } from './createCtx';

const [ctx, provider] = createCtx(AlertNotification.EMPTY);
export const AlertNotificationContext = ctx;
export const AlertNotificationProvider = provider;
